import React, { Component } from 'react';
import { Field, change, formValueSelector } from 'redux-form';
import MenuItem from 'material-ui/MenuItem';
import { connect } from 'react-redux';
import SearchableSelectRedux from 'components/shared/SearchableSelectRedux';
import { colors } from 'helpers/ColorHelper';
import SelectField from 'material-ui/SelectField';
import {
  getProperties,
  getUnits,
  getPropertyRooms,
  getUnitRooms,
} from 'actions/landlordPropertiesActions';
import * as validator from 'helpers/Validator';

const modes = {
  SELECTING_PROPERTY: 0,
  SELECTING_PROPERTY_MORE_SPECIFICALLY: 1,
  SELECTING_PROPERTY_ROOM: 2,
  SELECTING_UNIT: 3,
  SELECTING_UNIT_MORE_SPECIFICALLY: 4,
  SELECTING_UNIT_ROOM: 5,
};

const propertyOptionFields = [
  { value: 'directly_to_property', label: 'Assign to the Property' },
  { value: 'rooms_of_property', label: 'Room Owned by the Property' },
  { value: 'specific_unit_its_rooms', label: 'Unit within the Property' },
];
const unitOptionFields = [
  { value: 'directly_to_unit', label: 'Assign to the Unit' },
  { value: 'rooms_of_unit', label: 'Room within the Unit' },
];

const fieldStyle = { textAlign: 'left', fontSize: '14px' };
const labelStyle = {
  transform: 'scale(0.75) translateY(15px)',
  transformOrigin: 'left top 0px',
  color: colors.LABEL_GRAY,
  float: 'left',
};
const colStyle = { marginTop: '-20px' };
const colStyleNonSingleUnit = { marginTop: '0' };
class AssetAssignmentForm extends Component {
  constructor(props) {
    super(props);
    const { selectedProperty, selectedUnit, selectedRoom } = props;
    let propertyOption = null;
    let unitOption = null;

    if (!selectedProperty) {
      propertyOption = 'directly_to_property';
      unitOption = 'directly_to_unit';
    } else if (!selectedUnit && selectedRoom) {
      propertyOption = 'rooms_of_property';
      unitOption = 'directly_to_unit';
      this.loadPropertyRooms();
    } else if (!selectedUnit) {
      propertyOption = 'directly_to_property';
      unitOption = 'directly_to_unit';
    } else if (selectedUnit && selectedRoom) {
      propertyOption = 'specific_unit_its_rooms';
      unitOption = 'rooms_of_unit';
      this.loadPropertyUnits();
      this.loadUnitRooms();
    } else {
      propertyOption = 'specific_unit_its_rooms';
      unitOption = 'directly_to_unit';
      this.loadPropertyUnits();
    }

    this.state = {
      propertyOption: propertyOption,
      unitOption: unitOption,
    };
  }

  loadPropertyRooms = () => {
    const propertyId = this.props.selectedProperty.value;
    this.props.getPropertyRooms(propertyId, { for_multiselect: true });
  };
  loadPropertyUnits = () => {
    const propertyId = this.props.selectedProperty.value;
    this.props.getUnits(propertyId, { for_multiselect: true });
  };
  loadUnitRooms = () => {
    const unitId = this.props.selectedUnit.value;
    this.props.getUnitRooms(unitId, { for_multiselect: true });
  };

  resetPropertySelections = () => {
    this.props.change(this.props.formName, 'unit', null);
    this.props.change(this.props.formName, 'room', null);
  };

  resetUnitSelections = () => {
    this.props.change(this.props.formName, 'room', null);
  };

  handlePropertyOptionChange = (_e, _index, newValue) => {
    const { selectedProperty } = this.props;
    this.setState({
      propertyOption: newValue,
    });

    this.resetPropertySelections();
    if (newValue === 'specific_unit_its_rooms' && selectedProperty.is_single_unit) {
      const unit = {
        value: selectedProperty.unit_id,
        label: `${selectedProperty.label} Unit`,
      };
      this.props.change(this.props.formName, 'unit', unit);
    } else if (newValue === 'specific_unit_its_rooms') {
      this.loadPropertyUnits();
    } else if (newValue === 'rooms_of_property') {
      this.loadPropertyRooms();
    }
  };

  handleUnitOptionChange = (_e, _index, newValue) => {
    this.setState({
      unitOption: newValue,
    });

    this.resetUnitSelections();

    if (newValue === 'rooms_of_unit') {
      this.loadUnitRooms();
    }
  };

  determineMode = () => {
    const { selectedProperty, selectedUnit } = this.props;
    const { propertyOption, unitOption } = this.state;

    if (selectedProperty && propertyOption === 'rooms_of_property')
      return modes.SELECTING_PROPERTY_ROOM;
    else if (selectedProperty && propertyOption === 'specific_unit_its_rooms' && !selectedUnit)
      return modes.SELECTING_UNIT;
    else if (
      selectedProperty &&
      propertyOption === 'specific_unit_its_rooms' &&
      unitOption === 'rooms_of_unit'
    )
      return modes.SELECTING_UNIT_ROOM;
    else if (selectedProperty && propertyOption === 'specific_unit_its_rooms' && selectedUnit)
      return modes.SELECTING_UNIT_MORE_SPECIFICALLY;
    else if (selectedProperty) return modes.SELECTING_PROPERTY_MORE_SPECIFICALLY;
    else return modes.SELECTING_PROPERTY;
  };

  handlePropertyChange = () => {
    this.setState({
      propertyOption: 'directly_to_property',
      unitOption: 'directly_to_unit',
    });
    this.resetPropertySelections();
  };

  handleUnitChange = () => {
    this.setState({
      unitOption: 'directly_to_unit',
    });
    this.resetUnitSelections();
  };

  render() {
    const { properties } = this.props;

    return (
      <div>
        <div className="col-xs-12">
          <label style={labelStyle}>Property</label>
          <Field
            fullWidth
            name="property"
            component={SearchableSelectRedux}
            options={properties}
            onChange={this.handlePropertyChange}
            floatingLabel="Property"
            validate={[validator.required]}
          />
        </div>
        {this.renderPropertyOptionField()}
        {this.renderUnitSelectField()}
        {this.renderUnitOptionField()}
        {this.renderRoomSelectField()}
      </div>
    );
  }

  renderPropertyOptionField = () => {
    const currentMode = this.determineMode();
    if (currentMode === modes.SELECTING_PROPERTY) return null;
    return (
      <div className="col-xs-12">
        <label style={labelStyle}>Property Options</label>
        <SelectField
          fullWidth
          value={this.state.propertyOption}
          onChange={this.handlePropertyOptionChange}
          style={fieldStyle}
        >
          {propertyOptionFields.map(option => {
            return <MenuItem key={option.value} value={option.value} primaryText={option.label} />;
          })}
        </SelectField>
      </div>
    );
  };

  renderUnitSelectField = () => {
    const currentMode = this.determineMode();
    const modesToShow = [
      modes.SELECTING_UNIT,
      modes.SELECTING_UNIT_MORE_SPECIFICALLY,
      modes.SELECTING_UNIT_ROOM,
      modes.SELECTING_UNIT_ASSET,
    ];
    if (!modesToShow.includes(currentMode)) return null;
    if (this.props.selectedProperty.is_single_unit) return null;
    return (
      <div className="col-xs-12" style={colStyle}>
        <label style={labelStyle}>Unit</label>
        <Field
          fullWidth
          name="unit"
          component={SearchableSelectRedux}
          options={this.props.units}
          onChange={this.handleUnitChange}
          validate={[validator.required]}
        />
      </div>
    );
  };

  renderUnitOptionField = () => {
    const currentMode = this.determineMode();
    const modesToShow = [
      modes.SELECTING_UNIT_MORE_SPECIFICALLY,
      modes.SELECTING_UNIT_ROOM,
      modes.SELECTING_UNIT_ASSET,
    ];
    if (!modesToShow.includes(currentMode)) return null;
    const { is_single_unit } = this.props.selectedProperty;
    return (
      <div className="col-xs-12" style={is_single_unit ? colStyle : colStyleNonSingleUnit}>
        <label style={labelStyle}>Unit Options</label>
        <SelectField
          fullWidth
          value={this.state.unitOption}
          onChange={this.handleUnitOptionChange}
          style={fieldStyle}
        >
          {unitOptionFields.map(option => {
            return <MenuItem key={option.value} value={option.value} primaryText={option.label} />;
          })}
        </SelectField>
      </div>
    );
  };

  renderRoomSelectField = () => {
    const currentMode = this.determineMode();
    const modesToShow = [modes.SELECTING_PROPERTY_ROOM, modes.SELECTING_UNIT_ROOM];
    if (!modesToShow.includes(currentMode)) return null;
    return (
      <div className="col-xs-12" style={colStyle}>
        <label style={labelStyle}>Room</label>
        <Field
          fullWidth
          name="room"
          component={SearchableSelectRedux}
          options={this.props.rooms}
          validate={[validator.required]}
        />
      </div>
    );
  };
}

const mapStoreToProps = (store, ownProps) => {
  return {
    properties: store.landlordProperties.properties,
    units: store.landlordProperties.units,
    rooms: store.landlordProperties.rooms,
    selectedProperty: formValueSelector(ownProps.formName)(store, 'property'),
    selectedUnit: formValueSelector(ownProps.formName)(store, 'unit'),
    selectedRoom: formValueSelector(ownProps.formName)(store, 'room'),
  };
};

const mapDispatchToProps = {
  getUnits,
  getProperties,
  getPropertyRooms,
  getUnitRooms,
  change,
};

export default connect(mapStoreToProps, mapDispatchToProps)(AssetAssignmentForm);
